/* THE SIGN — announcement-bar.js
 * Zamykany pasek ogłoszeń; stan w localStorage (reset po zmianie treści).
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  var key = 'thesign:announcement-dismissed';
  var id = bar.getAttribute('data-announcement-id') || '';

  try {
    if (window.localStorage.getItem(key) === id) {
      bar.hidden = true;
      return;
    }
  } catch (error) {
    /* localStorage niedostępny — pasek działa bez pamięci */
  }

  var close = bar.querySelector('[data-announcement-close]');
  if (close) {
    close.addEventListener('click', function () {
      bar.hidden = true;
      try {
        window.localStorage.setItem(key, id);
      } catch (error) {
        /* ignoruj */
      }
    });
  }
})();
